import React from 'react';

import {GridCardSmall} from 'src/components/editorial/GridCardSmall';
import {TOPIC, EDITORIAL, CATEGORY} from 'src/routes/paths';
import {ChiefLogo} from 'src/svgs/chiefLogo';

import {SanityTopic, Maybe} from 'types/generated';

interface TopicProps {
  topic: SanityTopic;
}

export const TopicHeader: React.FC<TopicProps> = ({topic}: TopicProps) => {
  const featuredArticle = topic.featuredArticles?.featuredArticle;
  const firstArticle = topic.featuredArticles?.firstArticle;
  const secondArticle = topic.featuredArticles?.secondArticle;
  const thirdArticle = topic.featuredArticles?.thirdArticle;
  return (
    <section className="module-spacing pt-12" data-module="topic-hero">
      <div className="wrapper-default grid grid-cols-4 md:grid-cols-12 lg:gap-x8">
        {/* {# Featured Articles Grid #} */}
        <div className="col-span-full grid grid-cols-4 md:grid-cols-12 gap-8">
          {/* {# Featured Article #} */}
          <div className="col-span-full md:col-span-6">
            <div className="w-full lg:h-[400px]">
              <a href={`${EDITORIAL}/${featuredArticle?.slug?.current}`}>
                {featuredArticle?.heroImage?.asset?.url ? (
                  <img
                    className="object-cover w-full h-full"
                    src={featuredArticle?.heroImage?.asset?.url != null ? featuredArticle?.heroImage?.asset?.url : ''}
                    alt={featuredArticle?.heroImage?.asset?.altText || ''}
                  />
                ) : (
                  <div className="absolute w-full h-full object-cover bg-black flex items-center justify-center">
                    <ChiefLogo classes={'mb-2 lg:mb-0 h-[18px] lg:w-25 lg:h-[8%] fill-light-gold'} />
                  </div>
                )}
              </a>
            </div>
            {featuredArticle?.editorialCategory?.slug?.current ? (
              <a
                href={`${CATEGORY}/${featuredArticle?.editorialCategory?.slug?.current}`}
                className="type-eyebrow mt-5 md:mt-7 block text-green-dark link-eyebrow"
              >
                {featuredArticle?.editorialCategory?.title}
              </a>
            ) : (
              <span className="type-eyebrow mt-5 md:mt-7 block text-green-dark">
                {featuredArticle?.editorialCategory?.title}
              </span>
            )}
            <h3 className="type-gamma mt-1 md:mt-2">
              {featuredArticle?.slug?.current ? (
                <a href={`${EDITORIAL}/${featuredArticle?.slug?.current}`} className="link-text-black">
                  {featuredArticle?.title}
                </a>
              ) : (
                <span>{featuredArticle?.title}</span>
              )}
            </h3>
          </div>

          {/* {# Popular Articles #} */}
          <div className="col-span-full md:col-span-6 lg:ml-3 pt-2 md:pt-0">
            <span className="type-eta block pb-3 mb-6  mt-1 md:-mt-1 border-b w-full border-green-dark/30 capitalize">
              Most Popular
            </span>

            <div className="grid grid-cols-1 gap-y-6">
              <GridCardSmall article={firstArticle} />
              <GridCardSmall article={secondArticle} />
              <GridCardSmall article={thirdArticle} />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
